<template>
  <input
    type="time"
    lang="en-GB"
    :value="draft === null ? modelValue : draft"
    @input="draft = $event.target.value"
    @blur="commit"
    @keydown.enter="$event.target.blur()"
  />
</template>

<script>
// Native time input that saves once, when the user is done with it (blur, or Enter on desktop).
// Saving on `change` broke editing on iOS: the wheel fires `change` as soon as the hour settles,
// which saved a half-edited time and the reload closed the wheel before the minutes could be set.
export default {
  name: 'NativeTimeInput',
  props: {
    // Saved value, "HH:mm"
    modelValue: { type: String, default: '' },
    // async (value) => void, called once per finished edit
    save: { type: Function, required: true },
  },
  data() {
    return { draft: null, sentValue: null };
  },
  beforeUnmount() {
    // Flush an edit left open when navigating away without leaving the field
    this.commit();
  },
  methods: {
    async commit() {
      const value = this.draft;
      // Nothing edited, or already being saved (the browser can also fire blur when the input is removed)
      if (value === null || value === this.sentValue) return;
      if (value === this.modelValue) {
        this.draft = null;
        return;
      }
      this.sentValue = value;
      try {
        await this.save(value);
      } finally {
        this.sentValue = null;
        // Keep showing the edit until the save settles so the old time doesn't flash back
        if (this.draft === value) this.draft = null;
      }
    },
  },
};
</script>
